var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForecastingandRisk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(50,52) scale(1.12) translate(-50,-52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,82 H88"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 66,
    width: 13,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 54,
    width: 13,
    height: 28,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 44,
    width: 13,
    height: 38,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,74 L40,48 L52,50 L84,22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,22 L72,22 M84,22 L84,34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecastingandRisk);
export default __webpack_public_path__ + "static/media/Forecasting and Risk.5d6c2db08e84797cb18f0159ff80dc02.svg";
export { ForwardRef as ReactComponent };